import { render } from "./Scan.vue?vue&type=template&id=65d9af10"
import script from "./Scan.vue?vue&type=script&lang=js"
export * from "./Scan.vue?vue&type=script&lang=js"
script.render = render

export default script